<template>
  <div class="home">
    <div v-if="info.goodsName">
      <img :src="info.goodsImg">
      <p class="title">{{ info.goodsName }}</p>
      <div :key="componentKey">

        <div class="lineBox" v-if="info.unitList">
          <span class="lineName">杯型</span>
          <div class="valueBox">
            <div v-for="item in info.unitList" :key="item.skuId"
                 :class='["valueName",item.isSelect === true ? "isSelected" :""]'
                 @click="changeCup(item)">
              {{ item.unitName }}
            </div>
          </div>
        </div>

        <div v-for="item in info.modifyList" :key="item.subitemId" class="lineBox">
          <span class="lineName">{{ item.typeName }}</span>
          <div class="valueBox">
            <div v-for="son in item.data" :key="son.unitId"
                 :class='["valueName",son.isSelect === true ? "isSelected" :""]'
                 @click="changeSku(item,son)">
              {{ son.goodsName }}
            </div>
          </div>
        </div>

      </div>

      <div style="width: 80%;margin: 20px auto">
        <el-button style="width: 100%;background-color: #006DE7;border-color:#006DE7;" type="primary"
                   @click="dialogVisible = true">立即下单
        </el-button>
      </div>
    </div>


    <el-dialog
        :visible.sync="dialogVisible"
        title="确认下单"
        width="80%">
      <div class="sureInfo">
        <div style="display: flex">
          <p>下单店铺：</p>
          <p>{{ shopInfo.shopName }}</p>
        </div>
        <div style="display: flex">
          <p>下单商品：</p>
          <p>{{ info.goodsName }}</p>
        </div>

        <div style="display: flex">
          <p>下单规格：</p>
          <p>{{ selectedAttributesText }}</p>
        </div>

        <div style="display: flex;align-items: center">
          <p>下单备注：</p>
          <el-input v-model="remark" :rows="2" placeholder="请输入备注" type="textarea"></el-input>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="toOrder()">确 定</el-button>
  </span>
    </el-dialog>



    <el-dialog
        :visible.sync="showDialog"
        title="下单中"
        width="60%"
        :close-on-click-modal="false"
    >
      <span>{{loadingText}}</span>
      <template #footer>
        <el-button
            type="primary"
            @click="closeProcessingDialog"
            :loading="loading"
        >
          {{ loading ? '处理中...' : '确认' }}
        </el-button>
      </template>
    </el-dialog>


  </div>
</template>

<script>
import { getItem,updateTOP } from '../api/cbd'
import { generateUUID } from '../utils/uuid'
//import crypto from 'crypto'

export default {
  name: 'ProductView',
  
  data() {
    return {
      shopInfo: {},
      itemInfo:{},
      info: {},
      productAttrs: [],
      cups:[],
      cup:{},
      temperature: {},
      sugar: {},
      type:1,
      componentKey: 0,
      dialogVisible: false,
      remark: '',
      showDialog: false,
      loading: true,
      loadingText: '正在下单中，请稍等',
      orderFlag: false,
    }
  },

  computed: {
    selectedAttributesText() {
      if (!this.info) return ''
      //return `${this.temperature.attributeName}/${this.sugar.attributeName}`
      let text = ''
      this.info.unitList.forEach((option,index)=>{
        if (option.isSelect){
          text = option.unitName
        }
      })
      const productAttrs = this.info.modifyList
      productAttrs.forEach(attr => {
        attr.data.forEach((option) => {
          if (option.isSelect) {
            let ad = text ? `/${option.goodsName}` : option.goodsName
            text = text + ad
          }
        })
      })
      return text
    },

    orderParams() {
      return {
        shopID: this.shopInfo.shopID,
        shopName:this.shopInfo.shopName,
        shopAddress:this.shopInfo.address,
        shopTel:this.shopInfo.shopPhone,
        shopLongitude:this.shopInfo.shopLongitude,
        shopLatitude:this.shopInfo.shopLatitude,
        goodsId:this.info.goodsId,
        spuId:this.info.spuId,
        skuId:"",
        goodsName:this.info.goodsName,
        unitId:"",
        unitName:"",
        groupCustomerName:this.info.groupName,
        groupCustomer:this.info.groupId,
        goodsImg:this.info.goodsImg || 'https://cdn-online.shuxinyc.com/basic-information/picture/971752720291078144鲜奶茉莉-竹香杯.png',
        detailsItem:[],
        remark:this.remark,
        type:localStorage.getItem('type') || ""
      }
    }
  },

  created() {
    this.initializeData()
  },

  methods: {
    initItem(){
      let params = {
        url:this.itemInfo.urlDetail,
        shopID:this.shopInfo.shopID,
        type:localStorage.getItem('type') || ""
      }
      getItem(params).then(res=>{
        if (res.code !== 0) return
        this.info = res.data
        this.initializeProductAttributes()
      })
    },
    initializeData() {
      // Initialize card ID if present in route
      if (this.$route.query.cardID) {
        const cardID = this.$route.query.cardID
        localStorage.setItem('cardID', cardID)
      }

      // Load product and shop info
      this.itemInfo = JSON.parse(localStorage.getItem('itemInfo'))
      this.shopInfo = JSON.parse(localStorage.getItem('shopInfo'))
      this.type = localStorage.getItem('type')
      this.initItem()
      // Initialize product attributes
    },

    initializeProductAttributes() {
      const productAttrs = this.info.modifyList
      const cups = this.info.unitList

      productAttrs.forEach(attr => {
        attr.data.forEach((option, index) => {
          option.isSelect = index === 0
        })
      })


        cups.forEach((option, index) => {
          option.isSelect = index === 0
        })
      this.info.modifyList = productAttrs
      this.info.unitList = cups

      // this.productAttrs = productAttrs
      // this.cups = cups
      // this.temperature = productAttrs[0]?.productAttrs[0] || {}
      // this.sugar = productAttrs[1]?.productAttrs[0] || {}
      // this.cup = cups[0] || {}
    },

    changeSku(attribute, selectedOption) {
      // Update selection status in productAttrs
      this.info.modifyList = this.info.modifyList.map(attr => {
        if (attr.typeName === attribute.typeName) {
          attr.data = attr.data.map(option => ({
            ...option,
            isSelect: option.goodsName === selectedOption.goodsName
          }))
        }
        return attr
      })
      console.log(this.info,'this.info')

      // Force re-render of attributes section
      this.componentKey += 1
    },
    changeCup(item){

      this.info.unitList = this.info.unitList.map(attr => {
        attr.isSelect = attr.unitName === item.unitName
        return attr
      })

      // Force re-render of attributes section
      this.componentKey += 1
    },

    closeProcessingDialog() {
      if (!this.loading) {
        this.showDialog = false
      }
      if (this.loadingText.includes("下单成功")) return this.$router.push('/order')
    },

    async toOrder() {
      const value = JSON.parse(localStorage.getItem('value'))
      if (value.code !== 0) {
        this.$message.error(value.msg)
        return
      }

      if (this.orderFlag) return
      this.orderFlag = true
      this.showDialog = true

      try {
        const type = Number(localStorage.getItem('type'))
        //const apiCall = type === 1 || type === 4 ? update : updateADC
        //const apiCall = updateTOP
        this.info.unitList.forEach(item=>{
          if (item.isSelect){
            this.orderParams.skuId = item.skuId
            this.orderParams.unitId = item.unitId
            this.orderParams.unitName = item.unitName
          }
        })

        this.info.modifyList.forEach(acc=>{
          acc.data.forEach(ad=>{
            if (ad.isSelect){
              let accData ={}
              if (acc.typeName == "可换糖"){
                accData={
                  "amount": 1,
                  "productTypeCode": acc.typeCode,
                  "goodsId": ad.goodsId,
                  "spuId": ad.spuId,
                  "skuId": ad.skuId,
                  "goodsName": ad.goodsName,
                  "unitId": ad.unitId,
                  "unitName": ad.unitName,
                  "selected": true,
                  "groupCustomerName": acc.typeName,
                  "groupCustomer": ad.groupId,
                  "extrPay": "FqTl3UD1aXVnmnZ2Mg5Bdg==",
                  "uuid": generateUUID(),
                  "detailsItem": null,
                  "goodsExpand": "{}",
                  "goodsImg": ad.goodsImg,
                  "subitemId": ad.subitemId,
                  "goodsSubtype": ad.goodsSubtype.toUpperCase(),
                  "goodsCode": ad.spuId,
                  "SFMUnitCode": ""
                }
              }else{
                accData = {
                  "amount": 1,
                  "productTypeCode": acc.typeCode,
                  "goodsId": ad.goodsId,
                  "spuId": ad.spuId,
                  "waresShortCode": ad.waresShortCode,
                  "goodsName": ad.goodsName,
                  "unitId": null,
                  "unitName": null,
                  "selected": true,
                  "groupCustomerName": acc.typeName,
                  "groupCustomer": null,
                  "extrPay": "dw0pGPB6WdV6isBHB8Q1Sg==",
                  "uuid": generateUUID(),
                  "detailsItem": null,
                  "goodsExpand": "{}",
                  "goodsImg": null,
                  "subitemId": acc.subitemId,
                  "goodsSubtype": null,
                  "goodsCode": ad.goodsId,
                  "SFMUnitCode": ""
                }
              }
              this.orderParams.detailsItem.push(accData)

            }
          })

        })


        const res = await updateTOP(this.orderParams)
        
        this.handleOrderResponse(res)
      } catch (error) {
        this.handleOrderError(error)
      } finally {
        this.cleanupOrder()
      }
    },

    handleOrderResponse(res) {
      if (res.code !== 0) {
        this.loadingText = res.msg
        return
      }

      const value = { code: 1, msg: "已下单" }
      localStorage.setItem('value', JSON.stringify(value))
      
      this.loadingText = '下单成功，请前往取餐码页面查看'
      this.$message.success('下单成功，请前往取餐码页面查看')
    },

    handleOrderError(error) {
      console.log(error,'err')
      this.loadingText = '下单失败，请联系管理员'
      this.$message.error('下单失败，请联系管理员')
    },

    cleanupOrder() {
      this.loading = false
      this.dialogVisible = false
      this.orderFlag = false
      this.orderParams.detailsItem = []
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  margin-bottom: 80px;

  img {
    width: 100%;
    height: 300px;
    object-fit: cover;
  }

  .title {
    padding: 10px;
    font-size: 20px;
    font-weight: bold;
  }

  .skuItem {
    margin: 10px 0;
    padding: 6px 13px;
    border: 1px solid #F6E9EB;
    border-radius: 5px;
  }

  .isSelected {
    //border-color: #006DE7;
    background-color: #F6E9EB;
    color: #006DE7;
  }

  .sureInfo {
    font-size: 15px;

    p {
      min-width: 80px;
    }

    div:nth-child(2) {
      margin: 20px 0;
    }

  }

  /deep/ .el-dialog {
    margin-top: 30vh !important;
  }

  .el-button--primary {
    background-color: #006DE7;
    border-color: #006DE7;
  }

  //.search{
  //  width: 80%;
  //  margin: 50px auto 0 auto;
  //  display: flex;
  //  .search-ipt{
  //    margin-right: 20px;
  //  }
  //}
  //.choseDrink{
  //  width: 80%;
  //  margin: 20px auto 0 auto;
  //}
  //.drinkBox{
  //  margin-top: 20px;
  //  width: 100%;
  //  img{
  //    width: 100%;
  //  }
  .lineBox {
    display: flex;
    //align-items: center;
    padding: 10px 20px 0 20px;

    .lineName {
      font-size: 16px;
      font-weight: 200;
      min-width: 70px;
      line-height: 31px;
      margin: 10px 0 0 0;
    }

    .valueBox {
      display: flex;
      flex-wrap: wrap;

      .valueName {
        //color: #999999;
        min-width: 58px;
        font-size: 14px;
        font-weight: 200;
        text-align: center;
        //border: 1px solid #999999;
        border: 1px solid #000000;
        border-radius: 5px;
        //background-color: #F1F1F1;
        padding: 10px 13px;
        margin: 10px 20px 0 0;
      }

      .noShow {
        display: none;
      }

      .isSelected {
        //border-color: #989898;
        background-color: #FFF7F8;
        color: #006DE7;
      }
    }

  }

  //
  //  .sku{
  //    font-size: 14px;
  //    font-weight: 100;
  //    margin: 10px 20px;
  //  }
  //}
}
</style>
